export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-search-eye-line',
      title: 'Product Discovery',
      description: 'Find popular and trending products quickly without spending hours manually browsing through countless listings.',
    },
    {
      icon: 'ri-folders-line',
      title: 'Category Organization',
      description: 'Browse products by niche with 14+ well-organized categories, making it effortless to locate exactly what you need.',
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Shopping Efficiency',
      description: 'Reduce research time dramatically. What used to take hours now takes minutes with our organized spreadsheet.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Beginner Friendly',
      description: 'No prior experience needed. The spreadsheet is designed with simplicity in mind, perfect for new and experienced shoppers alike.',
    },
  ];

  return (
    <section id="benefits" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-4 tracking-wide">
            WHY CHOOSE US
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Why Thousands Of Users Choose
            <br />
            <span className="text-primary-500">Kakobuy Spreadsheet</span>
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Our spreadsheet has become the go-to resource for smart shoppers who value efficiency and organization.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}